import { memo, type ReactNode } from 'react'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

import { CreateOrganizationForm } from './create-organization-form.molecule'
import type { CreateOrganizationDialogProps } from './org-settings.interface'

const CreateOrganizationDialogBase: React.FC<CreateOrganizationDialogProps> = ({
  isOpen,
  onOpenChange,
  onSubmit,
  isLoading = false,
  className,
}): ReactNode => (
  <Dialog open={isOpen} onOpenChange={onOpenChange}>
    <DialogContent className={cn('create-organization-dialog sm:max-w-lg', className)}>
      <DialogHeader>
        <DialogTitle className="create-organization-dialog-title">Create Organization</DialogTitle>
        <DialogDescription className="create-organization-dialog-description">
          Set up a new organization with a name, URL, and optional logo.
        </DialogDescription>
      </DialogHeader>
      <CreateOrganizationForm
        onSubmit={onSubmit}
        onCancel={() => onOpenChange(false)}
        isLoading={isLoading}
        shouldReset={!isOpen}
      />
    </DialogContent>
  </Dialog>
)

export const CreateOrganizationDialog = memo(CreateOrganizationDialogBase)

CreateOrganizationDialog.displayName = 'CreateOrganizationDialog'
